import {safeParseJson} from '../../js/tools';

export class AnimatedText {
  elements = {
    root: null,
    characters: null,
  };
  state = {
  };
  data = {
  };
  options = {
    delay: .02,
  };

  get characterElements() {
    return this.elements.root.querySelectorAll('.character');
  }

  get wordElements() {
    return this.elements.root.querySelectorAll('.word');
  }

  get isCharacterMode() {
    return !this.elements.root.classList.contains('word-mode');
  }

  get delay() {
    return this.options.delay;
  }

  constructor(element, options) {
    this.elements = {
      root: element,
    };
    this.options.delay = options.delay ?? this.options.delay;

    this.splitNode(this.elements.root);
    this.wrapCharacterAndWordElements();

    if (this.isCharacterMode) {
      this.setAnimationDelayToCharacters();
    } else {
      this.setAnimationDelayToWords();
    }
  }

  splitNode(node) {
    const characters = [];
    for (const childNode of node.childNodes) {
      if (this.isTextNode(childNode)) {
        this.splitTextNode(childNode);
      } else if (this.isElementNode(childNode)) {
        this.splitNode(childNode);
      }
    }
  }

  splitTextNode(node) {
    const container = document.createElement('span');
    container.className = 'sentence';

    const words = node.textContent.trim().split(' ');
    const wordsWithSpaces = [];

    console.log(words)
    for (const [index, word] of Object.entries(words)) {
      if (word.length) {
        wordsWithSpaces.push(word + ' ');
      }
    }

    const wordSpans = wordsWithSpaces.map(word => {
      const span = document.createElement('span');

      span.className = 'word';
      // span.innerHTML = word;

      const characters = word.split('');
      const characterSpans = characters.map(character => {
        const _span = document.createElement('span');

        _span.className = 'character';
        _span.innerHTML = character;

        return _span;
      });

      span.append(...characterSpans);

      return span;
    });

    container.append(...wordSpans);

    if (!container.childElementCount) {
      container.className = '';
    }

    node.replaceWith(container);
  }

  wrapCharacterAndWordElements() {
    // some effects require characters/words to be inside a container
    for (const character of this.characterElements) {
      const container = document.createElement('span');

      container.className = 'character-container';
      character.after(container);
      container.append(character);
    }

    for (const character of this.wordElements) {
      const container = document.createElement('span');

      container.className = 'word-container';
      character.after(container);
      container.append(character);
    }
  }

  isElementNode(node) {
    return node.nodeType === 1;
  }

  isTextNode(node) {
    return node.nodeType === 3;
  }

  setAnimationDelayToCharacters() {
    for (const [index, element] of Object.entries(this.characterElements)) {
      const delay = this.delay * index;
      element.style.animationDelay = `${delay}s`;
    }
  }

  setAnimationDelayToWords() {
    for (const [index, element] of Object.entries(this.wordElements)) {
      const delay = this.delay * index;
      element.style.animationDelay = `${delay*5}s`; // looks better with more delay than character
    }
  }
}
